class FadeIn extends HTMLElement {
  static get observedAttributes() {
    return ['active'];
  }

  attributeChangedCallback(_name, oldValue, newValue) {
    if (oldValue !== newValue) {
      if (newValue === 'true') {
        this.addFade();
      } else {
        this.removeFade();
      }
    }
  }

  addFade() {
    const children = Array.from(this.children);

    children.forEach((child, index) => {
      const currentChild = child;

      setTimeout(() => {
        currentChild.classList.add('fade-in-active');
      }, [100 + 50 * index]);
    });
  }

  removeFade() {
    const children = Array.from(this.children);

    children.forEach((child) => {
      const currentChild = child;
      currentChild.classList.remove('fade-in-active');
    });
  }
}

if (!customElements.get('fade-in')) {
  customElements.define('fade-in', FadeIn);
}
